export const categories = {
  consideration: {
    name: 'Consideration',
    hasArrow: true,
    tasks: [
      {
        slug: 'plan-workflow',
        name: 'Plan workflow',
        hasSettings: true
      },
      {
        slug: 'request-prices',
        name: 'Request prices',
        hasSettings: true
      }
    ]
  },
  negotiation: {
    name: 'Negotiation',
    hasArrow: true,
    tasks: [
      {
        slug: 'price-entries',
        name: 'Price Entry',
        hasSettings: false
      },
      {
        slug: 'expiring-licenses',
        name: 'Expiring licenses',
        hasSettings: true
      },
      {
        slug: 'finalize-licenses',
        name: 'Finalize licenses',
        hasSettings: false
      },
      {
        slug: 'title-lists',
        name: 'Title lists',
        hasSettings: true
      }
    ]
  },
  decision: {
    name: 'Decision',
    hasArrow: true,
    tasks: [
      {
        slug: 'stakeholders',
        name: 'Stakeholders',
        hasSettings: true
      },
      {
        slug: 'evaluations',
        name: 'Evaluations',
        hasSettings: false
      },
      {
        slug: 'decisions',
        name: 'Decisions',
        hasSettings: false
      },
      {
        slug: 'place-orders',
        name: 'Place orders',
        hasSettings: true
      }
    ]
  },
  invoicing: {
    name: 'Invoicing',
    hasArrow: true,
    tasks: [
      {
        slug: 'approve-invoices',
        name: 'Approve invoices',
        hasSettings: false
      },
      {
        slug: 'vendor-payments',
        name: 'Vendor payments',
        hasSettings: false
      }
    ]
  },
  implementation: {
    name: 'Implementation',
    hasArrow: false,
    tasks: [
      {
        slug: 'implementations',
        name: 'Implementations',
        hasSettings: false
      },
      {
        slug: 'inform-users',
        name: 'Inform users',
        hasSettings: true
      }
    ]
  }
}
